import { withInstall } from '@zoryn/utils'
import Slider from './src/slider.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZSlider: SFCWithInstall<typeof Slider> = withInstall(Slider)
export default ZSlider

export * from './src/slider'
export * from './src/constants'
